export default {
  title: 'Zeitaktualisierung!',
  labels: {
    old_time: 'Vorherige Abholzeit:',
    new_time: 'Neue Abholzeit:',
    old_serve_time: 'Vorherige Servierzeit:',
    new_serve_time: 'Neue Servierzeit:',
  },
  buttons: {
    print: 'Drucken & Schließen',
    got_it: 'Verstanden',
  },
  feedback: {
    new_prep_time: 'Die Lieferzeit wurde aktualisiert. Bitte passe deinen Vorbereitungsplan entsprechend an.',
  },
  toasts: {
    something_went_wrong: 'Etwas ist schiefgelaufen, bitte versuche es erneut.',
  },
};
